import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../../ui/components/button/Button";
export const NotificationActions = ({ actions, collapsed, onActionClick, onExpand, }) => {
    const { t } = useTranslation(["common"]);
    if (!actions?.length && collapsed <= 1) {
        return null;
    }
    return (React.createElement("div", { className: "flex gap-x-1" },
        actions?.map((action) => (React.createElement(Button, { buttonType: "tertiary", filled: "weak", key: action.title ?? action.icon, size: "xs", onClick: onActionClick(action.title) }, t(action.title, { count: collapsed })))),
        collapsed > 1 && onExpand && (React.createElement(Button, { buttonType: "tertiary", filled: "weak", size: "xs", onClick: onExpand }, t("{{ count }} More", { count: collapsed - 1 })))));
};
